import fractionBuilder from './fractionBuilder';
import Fraction from './fractionClass';
import gcd from './gcd';
import Surd from './surdClass';
import brackets from './brackets';
export default class Complex {
    constructor(a, b, denom = 1) {
        this.a = a;
        this.b = b;
        if (this.denom == 0) {
            throw "denom 0";
        }
        this.denom = denom;
        this.r = new Surd(1, new Fraction(a * a + b * b, denom));
        if (this.a == 0) { // purely imaginary
            this.theta = fractionBuilder("\\pi", 2);
            if (this.b < 0) {
                this.theta = "-" + this.theta;
            }
        }
        else if (this.b == 0) { // real
            if (this.a > 0) {
                this.theta = "0";
            }
            else {
                this.theta = "-\\pi";
            }
        }
        else if (Math.abs(a) == Math.abs(b)) { // pi/4
            if (a > 0) {
                this.theta = fractionBuilder("\\pi", 4);
                if (b < 0) {
                    this.theta = "-" + this.theta;
                }
            }
            else {
                this.theta = fractionBuilder("3\\pi", 4);
                if (b < 0) {
                    this.theta = "-" + this.theta;
                }
            }
        }
        else {
            const angle = Math.atan(this.b / this.a);
            if (this.a < 0) {
                if (this.b > 0) { // 2nd quadrant
                    this.theta = (Math.PI + angle).toPrecision(3);
                }
                else { // 3rd quadrant
                    this.theta = (-(Math.PI - angle)).toPrecision(3);
                }
            }
            else {
                this.theta = angle.toPrecision(3);
            }
        }
    }
    ;
    simplify() {
        let myGcd = gcd(gcd(this.a, this.b), this.denom);
        this.a = this.a / myGcd;
        this.b = this.b / myGcd;
        this.denom = this.denom / myGcd;
    }
    toString(cartesianMode = true) {
        if (cartesianMode) {
            let aString = "", signString = "", bString = "";
            if (this.a != 0) {
                aString = this.a.toString();
                if (this.b != 0) {
                    if (this.b > 0) {
                        signString = "+";
                    }
                }
            }
            if (this.b != 0) {
                if (this.b == 1) {
                    bString = "i";
                }
                else if (this.b == -1) {
                    bString = "-i";
                }
                else {
                    bString = this.b.toString() + "i";
                }
            }
            let zString = aString + signString + bString;
            if (this.a == 0 && this.b == 0) {
                zString = "0";
            }
            if (this.denom == 1 || zString == "0") {
                return zString;
            }
            else {
                return fractionBuilder(zString, this.denom);
            }
        }
        else { // exponential
            if (this.a == 0 && this.b == 0) {
                return "0";
            }
            const rString = (this.r.toString() == "1") ? "" : this.r.toString();
            const expString = brackets(this.theta + "i", "", "e^{", "}");
            return rString + expString;
        }
    }
    add(z) {
        if (typeof z === "number") {
            z = new Complex(z, 0);
        }
        let newA = z.denom * this.a + this.denom * z.a;
        let newB = z.denom * this.b + this.denom * z.b;
        let newDenom = this.denom * z.denom;
        let newZ = new Complex(newA, newB, newDenom);
        newZ.simplify();
        return newZ;
    }
    multiply(z) {
        if (typeof z === "number") {
            z = new Complex(z, 0);
        }
        let newA = this.a * z.a - this.b * z.b;
        let newB = this.b * z.a + this.a * z.b;
        let newDenom = this.denom * z.denom;
        let newZ = new Complex(newA, newB, newDenom);
        newZ.simplify();
        return newZ;
    }
    minus(z) {
        if (typeof z === "number") {
            z = new Complex(z, 0);
        }
        return this.add(z.multiply(-1));
    }
    divide(z) {
        let z2;
        if (typeof z === "number") {
            z2 = new Complex(z, 0);
        }
        else {
            z2 = new Complex(z.a, z.b, z.denom);
        }
        z2.b *= -1;
        let newZ = this.multiply(z2);
        newZ.denom *= (z2.a * z2.a + z2.b * z2.b);
        newZ.simplify();
        if (typeof z !== "number") {
        }
        return newZ;
    }
    pow(n) {
        let oldZ = new Complex(this.a, this.b, this.denom);
        let newZ = new Complex(1, 0);
        for (let i = 0; i < n; i++) {
            newZ = newZ.multiply(oldZ);
        }
        return newZ;
    }
}
